export const steps = [
  {
    id: "I",
    desc: "SECTION I",
    completed: false,
    highlighted: true,
    selected: true,
  },
  {
    id: "II",
    desc: "SECTION II",
    completed: false,
    highlighted: false,
    selected: false,
  },

  {
    id: "III",
    desc: "SECTION III",
    completed: false,
    highlighted: false,
    selected: false,
  },
  {
    id: "IV",
    desc: "SECTION IV",
    completed: false,
    highlighted: false,
    selected: false,
  },

  {
    id: "V",
    desc: "SECTION V",
    completed: false,
    highlighted: false,
    selected: false,
  },
];
